import { render, staticRenderFns } from "./provider-assignment-form.vue?vue&type=template&id=d7da6704"
import script from "./provider-assignment-form.vue?vue&type=script&lang=js"
export * from "./provider-assignment-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports